import { render, staticRenderFns } from "./AppInstallSuccessDialog.vue?vue&type=template&id=5cdf141b"
import script from "./AppInstallSuccessDialog.vue?vue&type=script&lang=js"
export * from "./AppInstallSuccessDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports